import React from "react";
import styles from "../styles/styles";
import { getCategoryColor } from "../util/categoryColor";

export default function EmergencyMatrix({
    cars = [],
    categoryLabel = "Emergência",
    rows = [],
    matrixData = {}
}) {

    return (

        <div style={styles.emergencyMatrixWrapper}>

            <table style={styles.pantographTable}>

                <thead>
                    <tr>
                        <th style={{ width: "40px" }}></th>
                        <th style={{ width: "180px" }}></th>
                    </tr>
                </thead>

                <tbody>

                    {rows.map((row, rowIndex) => (

                        <tr key={rowIndex}>

                            {rowIndex === 0 && (
                                <td
                                    rowSpan={rows.length}
                                    style={styles.emergencyMatrixVertical}
                                >
                                    {categoryLabel}
                                </td>
                            )}

                            <td
                                style={{
                                    ...styles.emergencyMatrixLabel,

                                    borderTop:
                                        rowIndex === 0
                                            ? "1px solid #9ca3af"
                                            : "none",

                                    borderBottom:
                                        rowIndex === rows.length - 1
                                            ? "1px solid #9ca3af"
                                            : "none"
                                }}
                            >
                                {row.label}
                            </td>

                            {cars.map(car => {

                                const value =
                                    matrixData?.[car]?.[row.key];
                                const categories =
                                    matrixData?.[car]?.[
                                    `${row.key}Category`
                                    ] ?? {};

                                return (

                                    <td
                                        key={car}
                                        style={styles.emergencyMatrixCell}
                                    >

                                        {row.type === "squares" && (

                                            <SquareGroup
                                                activeIndexes={value ?? []}
                                                categories={categories}
                                            />

                                        )}

                                        {row.type === "alert" && (

                                            <div
                                                style={{
                                                    ...styles.emergencyMatrixAlertBox,

                                                    background:
                                                        value
                                                            ? (
                                                                getCategoryColor(
                                                                    matrixData?.[car]?.botaoSocoCategory
                                                                ) || "#ef4444"
                                                            )
                                                            : "#ffffff",

                                                    color:
                                                        value
                                                            ? "#ffffff"
                                                            : "#111827"
                                                }}
                                            >
                                                {row.value}
                                            </div>

                                        )}

                                    </td>
                                );
                            })}

                        </tr>
                    ))}

                </tbody>

            </table>

        </div>
    );
}
function SquareGroup({
    activeIndexes = [],
    categories = {}
}) {

    return (

        <div style={styles.emergencyMatrixSquareGroup}>

            {Array.from({ length: 2 }).map((_, i) => (

                <div
                    key={i}

                    style={{
                        ...styles.emergencyMatrixSquare,

                        background:
                            activeIndexes.includes(i)
                                ? (
                                    getCategoryColor(
                                        categories[i]
                                    ) || "#ef4444"
                                )
                                : "#ffffff",

                        color:
                            activeIndexes.includes(i)
                                ? "#ffffff"
                                : "#111827"
                    }}
                />

            ))}

        </div>

    );
}